import * as React from 'react';

import {LandingSymbolConfigurationContext, frameworkLandingSymbol} from './landingsymbolconfiguration';

const withSymbolConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <LandingSymbolConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkLandingSymbol}/>
                );
            }}
        </LandingSymbolConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withSymbolConfiguration;